// extracted by mini-css-extract-plugin
export default {"left":"ArrowButton_left__JyX2I"};